import { render } from "./NotFound.vue?vue&type=template&id=bf973252&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=bf973252&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bf973252"

export default script